import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Box, IconButton, Typography } from "@mui/material";
import { type FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useHospitalData } from "../../../contexts/HospitalDataProvider";

export const HoursSummaryHeader: FC = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const { chosenDepartment } = useHospitalData();

	const handleBack = useCallback(() => {
		const qs = searchParams.toString();
		navigate(`/${chosenDepartment.department_id}/cost-deep-dive${qs ? `?${qs}` : ""}`);
	}, [searchParams, navigate, chosenDepartment.department_id]);

	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				justifyContent: "space-between",
				width: "100%",
				mb: 2,
			}}
		>
			<Box
				sx={{
					display: "flex",
					alignItems: "center",
					gap: 1,
				}}
			>
				<IconButton onClick={handleBack} aria-label={t("hours.summary.back")}>
					<ArrowBackIcon />
				</IconButton>
				<Typography
					variant="h6"
					sx={{
						fontWeight: 600,
					}}
				>
					{t("hours.summary.title")}
				</Typography>
			</Box>
		</Box>
	);
};
